import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incr-list-auth',
  templateUrl: './incr-list-auth.component.html',
  styleUrls: ['./incr-list-auth.component.css']
})
export class IncrListAuthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Increments/increment-list-authorization/incr-list-auth/incr-list-auth.component.ts